import React from 'react'
import PropTypes from 'prop-types'

import Util from './Util'
import { NumericInput, LabelGroup, Flex } from '~/views';

export default class StepInterpolatorEditor extends React.Component {

  static TYPE = 'step'

  static propTypes = {
    interpolator : PropTypes.object,
    attributeType : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = Util.ChangePath.bind( this )
  }

  render() {
    const { interpolator : mdl } = this.props
    if ( mdl == null ) {
      return <div />
    }
    return (
      <Flex variant="vSpace" direction="column" align="stretch">
        
        <LabelGroup>
          <label>Update Every</label>
          <div>
            <NumericInput
              hint="Seconds..." 
              value={mdl.update / 1000}
              float
              size={5}
              min={0}
              onChange={( v, err ) => { this.changePath( 'update', typeof v === 'number' ? v * 1000 : v, err ) }} />
            <label style={{ margin : '0 8px' }}> seconds</label>
          </div>
        </LabelGroup>
        <LabelGroup>
          <label>Change at </label>
          <NumericInput
            hint="Change at..."
            style={{ width : '80px' }}
            size={5}
            min={0}
            max={100}
            value={Math.round( 100 * mdl.stepAt )}
            onChange={( v, err ) => { this.changePath( 'stepAt', v / 100, err ) }} />
          <label>%</label>
        </LabelGroup>
        
      </Flex>
    ) 
  }
}
